/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { ColumnPropertySetter } from "./ColumnPropertySetter";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ColumnPropertySettersCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnPropertySettersCollection, _super);
    function ColumnPropertySettersCollection() {
        return _super.call(this, ColumnPropertySetter.$, 0) || this;
    }
    ColumnPropertySettersCollection.$t = markType(ColumnPropertySettersCollection, 'ColumnPropertySettersCollection', ObservableCollection$1.$.specialize(ColumnPropertySetter.$));
    return ColumnPropertySettersCollection;
}(ObservableCollection$1));
export { ColumnPropertySettersCollection };
//# sourceMappingURL=ColumnPropertySettersCollection.js.map
